import { doWaitImageByTime, isFollowingVanessaLead } from './../helpers/helpers';
import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import { mc } from "../characters/MC";
import { images } from "./images";
import { V8JoeMCMorningAfter } from "./V8";
import { joe } from '../characters/Joe';
import Question from '../../src/shell/Questions';

export const V8JoeMCMorning = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8JoeMCMorningLivingRoom_0);
    mc.think(`Joey? What is he doing here?`);
    ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_1);
    joe.talk(`Morning bro!`);
    ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_2);
    mc.talk(`Not that I'm complaining, but what are you doing here?`);

    joe.talk(`I just wanted to hang out... Maybe talk for a bit.`);
    ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_3);
    joe.talk(`Emily let me in. I hope it's ok with you.`);
    joe.talk(`I didn't want to use my spare key since you aren't alone in the house anymore.`);
    ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_6);
    mc.talk(`Yes, it's fine! Of course!`);

    if (mc.properties.gotKissedByEmily) {
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_5);
        mc.talk(`Did... Emily act normally? And did she say anything when she let you in...?`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_7);
        joe.talk(`She just told me I could wait for you to wake up.`);
        joe.talk(`Why? Does she need to tell me something?`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_5);
        mc.talk(`Oh no! I was just curious, that's all.`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_7);
        joe.talk(`Are you sure? You are acting a bit weird.`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_6);
        mc.talk(`No, no. Everything is fine, just forget about it.`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_5);
        mc.talk(`What about you? You said you have something you wanna talk about.`);

    } else {
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_5);
        mc.talk(`So what's on your mind? You said you wanna talk about something.`);
    }
    ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8);
    joe.talk(`So you know that me and Vanessa are having issues right now...`);
    mc.talk(`Yep.`);
    if (Question.globalAnswers.v7JoeGymToldBreakupVanessa) {
        mc.talk(`Didn't you plan to break up with her?`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p);
        joe.talk(`Yeah... And I did.`);
        joe.talk(`It was so weird. She said something about that, that she does the dumping.`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_2);
        joe.talk(`So I'm not sure if we are still together or not...`);
        joe.talk(`I told her what's on my mind.`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_3);
        mc.talk(`I guess that is it.`);
        mc.talk(`It doesn't really matter what she says. You basically broke up with her.`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_2);
        joe.talk(`Yeah... I guess that's right.`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_3);
        mc.talk(`How are you feeling?`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_4);
        joe.talk(`To be honest? Free.`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5);
        joe.talk(`Though it's not like she ever limited me.`);
        joe.talk(`I can't really explain it.`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5_1);
        mc.talk(`I think I understand.`);
        mc.talk(`So now what? Are you going to take a break from girls for a while?`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_6);
        joe.talk(`Fuck no!`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_4);
        joe.talk(`I actually wanted to ask you to be my wingman!`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5_1);
        mc.talk(`Already?`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_4);
        joe.talk(`Rebound sex is the best sex!`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5_1);
        mc.talk(`Haha.`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_7);
        joe.talk(`So what do you say? Are you in?`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_8);
        mc.talk(`Of course man!`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_17);
        joe.talk(`I knew I could count on you!`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_18);
        joe.talk(`I'll try to think of a good place to go, and I'll let you know!`);

    } else {
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_2);
        joe.talk(`So I had a talk with her...`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p);
        joe.talk(`I tried to explain what's on my mind...`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_3);
        mc.talk(`How did she respond?`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_2);
        joe.talk(`Like she usually does...`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_3);
        mc.talk(`I think I understand.`);
        if (isFollowingVanessaLead()) {
            ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p);
            joe.talk(`She basically said I'm not enough for her.`);
            ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_3);
            mc.talk(`Wow. That's... Rude.`);
            ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_2);
            joe.talk(`You know... She didn't straight out say it like that...`);
            joe.talk(`She has an ability to spin things to make them sound better than what they really are.`);
            ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_3);
            mc.talk(`How can you make that sound better?`);
            ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_4);
            joe.talk(`She was like... "Darling, you know you are the most important thing to me but sometimes I miss my old life..."`);
            ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5);
            joe.talk(`"...Where I could do everything I wanted, when I wanted, and I was happy to give that away for you!"`);
            joe.talk(`"...But sometimes I really miss it!"`);
            ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5_1);
            mc.talk(`Ah... That doesn't sound way better.`);
            ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8);
            joe.talk(`Yeah... I'm realizing that now...`);
            ImageClass.setImage({ ...images.v8.V8JoeMCMorningLivingRoom_8, partialsToDisplay: [images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5, images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5_1] });
            mc.talk(`So what are you going to do?`);

            if (Question.globalAnswers.v5JoeyBeachThreeSomeQuestion === "IWouldAgree") {

                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5);
                joe.talk(`That's where you come in...`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5_1);
                mc.talk(`Me...?`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5);
                joe.talk(`Yeah..`);
                joe.talk(`This might get weird... But hear me out.`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5_1);
                mc.talk(`I'm listening.`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5);
                joe.talk(`One of the things she said she's really missing is... Threesomes...`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5_1);
                mc.think(`I know where he is going with this.`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5);
                joe.talk(`Since you are my best friend and I trust you... I figured I should ask you if you wanna do it with me.`);
                await V8JoeMCMorningThreesomeQuestion();
            } else {
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5);
                joe.talk(`I hate asking you to get involved with my mess.`);
                joe.talk(`But I was wondering if maybe you could talk to her for me.`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5_1);
                mc.talk(`I can... But I feel like it's something you should do.`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5);
                joe.talk(`I know man... But I'm in a place of no return.`);
                joe.talk(`I don't care at this point... And besides, she really likes you, she will say things to you that she would hold back from me.`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5_1);
                mc.talk(`I'll see what I can do.`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_7);
                joe.talk(`Thanks bro! You are a lifesaver!`);
            }
        } else {
            ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_2);
            joe.talk(`But there is another issue now.`);
            joe.talk(`Basically the only thing that kept us together was the sex...`);
            ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p);
            joe.talk(`But for some reason she keeps holding it back from me lately.`);
            joe.talk(`Which is so weird. She is like the horniest person in the planet!`);
            mc.think(`Oh shit... She does keep her promises.`);
            ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_3);
            mc.talk(`Do you know why?`);

            if (Question.globalAnswers.v5JoeyBeachThreeSomeQuestion === "IWouldAgree") {
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_2);
                joe.talk(`I have an idea...`);
                joe.talk(`She kept saying she wants to have sex with me and another guy...`);
                joe.talk(`She'd told me she respects me and wants me to pick the guy...`);
                mc.think(`I think I know where he is going with this...`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5);
                joe.talk(`I think I made her wait too long and now she is holding sex from me until I tell her I'm ready.`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5_1);
                mc.talk(`Are you even ok with that?`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_6);
                joe.talk(`Of course! I don't give a fuck!`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_8);
                mc.talk(`So why did it take you so much time?`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5);
                joe.talk(`Well...`);
                doWaitImageByTime(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_4);
                joe.talk(`That's where you come in...`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5);
                joe.talk(`I wanted to ask you for so long, and I even hinted a few times...`);
                joe.talk(`I was afraid to ask you right away, since I know it might be weird...`);
                joe.talk(`You see? We didn't talk for so long, and it would've been so weird if I showed up at your door after such a long time and asked the question.`);
                await V8JoeMCMorningThreesomeQuestion();


            } else {
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_2);
                joe.talk(`I have no idea...`);
                joe.talk(`I figured you could have a chat with her...`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_3);
                mc.talk(`Me? Why me?`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_4);
                joe.talk(`She really likes you.`);
                if (Question.globalAnswers.v6HadSexVanessaLivingRoom) {

                    mc.think(`That's true...`);
                }
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5_1);
                mc.talk(`I can try and talk to her. Of course.`);
                ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5);
                joe.talk(`Really?`);
                joe.talk(`Thanks bro! You are a lifesaver!`);

            }

        }
    }


    doWaitImageByTime(images.v8.V8JoeMCMorningLivingRoom_3);
    joe.talk(`Alright bro! Nice seeing you. I'm gonna head to the gym.`);
    mc.talk(`Cya!`);
    ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_3.partials.V8JoeMCMorningLivingRoom_3_p, { duration: 1, wait: true, hideText: true });


    return jump(V8JoeMCMorningAfter, "V8JoeMCMorningAfter");
};

export const V8JoeMCMorningThreesomeQuestion = async (): Promise<any> => {
    ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5_1);
    await joe.setQuestion(new Question({ text: `So... What do you say?`, options: { think: false }, key: `v8JoeMorningAgreeThreesomeWithVanessa` })
        .option({ title: `Agree`, key: true })
        .option({ title: `Disagree`, key: false }));


    if (Question.globalAnswers.v8JoeMorningAgreeThreesomeWithVanessa) {
        mc.talk(`Of course!`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_5);
        joe.talk(`Really bro? You are a lifesaver!`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_7);
        mc.talk(`I wouldn't ask it from anyone else! You are the only one I can trust to do that with me.`);
        if (Question.globalAnswers.v6HadSexVanessaLivingRoom) {
            mc.think(`Oh Joey, my friend... If you only knew...`);
        }
        joe.talk(`I'll talk to you once I set some things up.`);
        joe.talk(`It's probably going to be today! I hope you are ready for it.`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_8);
        mc.talk(`Of course I am!`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_7);
        joe.talk(`Great to hear! I'll call you later with all the details.`);
    } else {
        mc.talk(`I don't think so man...`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p);
        joe.talk(`Damn...`);
        ImageClass.setImage(images.v8.V8JoeMCMorningLivingRoom_8.partials.V8JoeMCMorningLivingRoom_8_p_2);
        joe.talk(`I understand... It's me basically asking you to fuck my girlfriend with me...`);
        joe.talk(`I had a feeling you'd say no...`);


    }
};